<template>
  <div>
    <div id="container" class="amap-wrapper">
    </div>
    <div class="mapInfo">
      <p class="info-title">{{plotsName}}</p>
      <ul class="info-list">
        <li class="info-row zoom" v-for="item in plotInfo" v-if="item.content">
          <span class="info-key">{{item.title}}</span>
          <div class="info-value">{{item.content}}</div>
        </li>
      </ul>
    </div>

    <div class="mapControls">
      <div class="layerSwitch iconfont icon-satellite" :class="{Satellite: showSatellite}" v-tap.prevent="{ methods : changeShowSatellite }"></div>
      <div class="mapZoom">
        <a class="zoomIn" v-tap.prevent="{ methods : zoomIn }">+</a>
        <a class="zoomOut" v-tap.prevent="{ methods : zoomOut }">-</a>
      </div>
    </div>
  </div>
</template>
<script>
  // import { AMapManager } from 'vue-amap';
  // let amapManager = new AMapManager();

  const AMap = window.AMap;
  const satellite = new AMap.TileLayer.Satellite(); //卫星模式
  const mapTileLayer = new AMap.TileLayer(); //地图模式
  export default {
    data(){
      return {
        plotsName: '',
        plotInfo: [],
        plotCenter: [],
        map: null,
        // currentLayer: '卫星',
        showSatellite: true
      }
    },
    methods: {
      changeShowSatellite(){
        this.showSatellite = !this.showSatellite
      },
      zoomIn(){
        if (this.map) {
          this.map.zoomIn();
        }
      },
      zoomOut(){
        if (this.map) {
          this.map.zoomOut();
        }
      },
      areaCalc(area, unit){ //面积统一换算为亩
        let res = area * 1;
        if (unit == 0) { //平方米  1平方米=0.0015亩
          res = area * 0.0015;
        } else if (unit == 1) { //亩
          res = area * 1;
        } else if (unit == 2) { //公顷  1公顷=15亩
          res = area * 15;
        }
        if (isNaN(res)) {
          return 0;
        }
        return res.toFixed(5) * 1;
      },
      timeFormat(time){
        return time.split(' ')[0];
      },
      getData(){
        const plotsData = JSON.parse(localStorage.getItem('plotsData'));
        const {ContractBeginTime, ContractEndTime, PlotsName} = plotsData;
        this.plotsName = PlotsName;
        let list = [];
        if (plotsData.OrgName && plotsData.OrgName.length > 0) {
          list.push({title: '所属机构', content: plotsData.OrgName});
        } else {
          list.push({title: '所属机构', content: plotsData.CorpName});
        }
        list.push({title: '面积', content: this.areaCalc(plotsData.Area, plotsData.AreaUnit) + '亩'});
        list.push({title: '负责人', content: plotsData.ContractBy});
        if (ContractBeginTime && ContractEndTime) {
          list.push({title: '起止时间', content: `${this.timeFormat(ContractBeginTime)} - ${this.timeFormat(ContractEndTime)}`});
        } else {
          list.push({title: '起止时间', content: '长期'});
        }
        this.plotInfo = list;
        this.plotCenter = [plotsData.Longitude, plotsData.Latitude];
      }
    },
    watch: {
      showSatellite(val){
        val ? satellite.show() : satellite.hide();
      }
    },
    created(){
      this.getData();
    },
    mounted(){
      const map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 11,
        center: this.plotCenter,
        layers: [satellite, mapTileLayer]
      });
      map.setZoomAndCenter(11, this.plotCenter);
      new AMap.Marker({
        map: map,
        position: this.plotCenter
      });
      this.map = map;
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        //vm.$store.commit('setPageTitle', '地块信息');
        vm.$store.commit('setPageTitle', '基地信息');
        vm.$store.commit('changeGestureState', false);
        vm.$store.commit('setState', {name: 'headFooterStyle', value: {backgroundColor: 'rgba(0,0,0,0.3)'}});
      })
    },
    beforeRouteLeave(to, from, next){
      this.$store.commit('setState', {name: 'headFooterStyle', value: {backgroundColor: 'transparent'}});
      next();
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';

  .amap-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    width: 100%;
  }

  .mapInfo {
    position: fixed;
    right: 30px;
    top: 180px;
    z-index: 10;
    width: 580px;
    padding: 60px 40px;
    border-radius: 16px;
    color: #333;
    background: rgba(255, 255, 255, 0.9)
  }

  .info-title {
    .singleLineTxt;
    display: block;
    font-size: @font-size-larger;
    text-align: center;
  }

  .info-list {
    margin-top: 40px;
  }

  .info-row {
    font-size: @font-size-normal;
    list-style: none;
    line-height: 1.6em;
  }

  .info-key {
    float: left;
    font-weight: bold;
    width: 100px;
    margin-right: 32px;
  }

  .info-value {
    margin-left: 142px;
  }

  .mapControls {
    position: fixed;
    right: 15px;
    bottom: 80px;
    width: 48px;
    z-index: 100;
    text-align: center;
    font-size: 22px;
    text-align: center;
  }

  .layerSwitch {
    height: 48px;
    line-height: 48px;
    margin-bottom: 16px;
    color: #333;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  .Satellite {
    color: #2c9eff;
  }

  .mapZoom {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  .zoomIn {
    font-size: 28px;
    font-weight: bold;
    display: block;
    margin: 0 8px;
    height: 48px;
    line-height: 48px;
    color: #333;
  }

  .zoomOut {
    font-size: 28px;
    font-weight: bold;
    display: block;
    margin: 0 8px;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #ccc;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// index.vue?44278f79